import camelCase from '../lib/camelCase';
import _ from 'lodash';
import Immutable from 'immutable';
import qs from 'qs';
import underscore from '../lib/underscore';

function transformObject(obj) {
    if (Array.isArray(obj)) {
        return obj.map(item => transformObject(item));
    }

    if (obj.createdAt) obj.createdAt = new Date(obj.createdAt);
    if (obj.updatedAt) obj.updatedAt = new Date(obj.updatedAt);
    if (obj.deletedAt) obj.deletedAt = new Date(obj.deletedAt);
    if (obj.addressbook) obj.addressbook = transformObject(obj.addressbook);
    if (obj.billing) obj.billing = transformObject(obj.billing);
    if (obj.address) obj.address = transformObject(obj.address);

    return obj;
}

function transformLocationsFromApi(payload) {
    return transformObject(camelCase(payload));
}

export function get(api) {
    return api.get(api.url('locations'), {
        transformResponse(json) {
            const response = JSON.parse(json);
            return response && response.payload
                ? Immutable.fromJS(transformLocationsFromApi(response.payload))
                : response;
        },
    });
}

export function create(api, location) {
    const data = Immutable.Iterable.isIterable(location)
        ? location.toJSON()
        : location;

    if (_.has(data, 'address.region')) {
        _.set(data, 'address.region_id', _.get(data, 'address.region'));
        delete data.address.region;
    }
    if (_.has(data, 'billing.address.region')) {
        _.set(data, 'billing.address.region_id', _.get(data, 'billing.address.region'));
        delete data.billing.address.region;
    }

    return api.post(api.url('locations/store'), underscore(data), {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'X-Requested-With': 'XMLHttpRequest',
        },
        transformRequest(payload) {
            return qs.stringify(payload);
        },
        transformResponse(json) {
            const response = JSON.parse(json);
            if (response.payload) {
                return response && response.payload
                    ? Immutable.fromJS(transformLocationsFromApi(response.payload))
                    : response;
            }
            return response
                ? Immutable.fromJS(camelCase(response))
                : response;
        },
    });
}

export function hide(api, id) {
    return api.post(api.url('locations/' + id + '/hide'), underscore({}), {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'X-Requested-With': 'XMLHttpRequest',
        },
        transformRequest(payload) {
            return qs.stringify(payload);
        },
        transformResponse(json) {
            const response = JSON.parse(json);
            if (response.payload) {
                return response && response.payload
                    ? Immutable.fromJS(transformLocationsFromApi(response.payload))
                    : response;
            }
            return response
                ? Immutable.fromJS(camelCase(response))
                : response;
        },
    });
}

export function update(api, location) {
    const data = Immutable.Iterable.isIterable(location)
        ? location.toJSON()
        : location;

    return api.post(api.url('locations/update'), underscore(data), {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'X-Requested-With': 'XMLHttpRequest',
        },
        transformRequest(payload) {
            return qs.stringify(payload);
        },
        transformResponse(json) {
            const response = JSON.parse(json);
            if (response.payload) {
                return response && response.payload
                    ? Immutable.fromJS(transformLocationsFromApi(response.payload))
                    : response;
            }
            return response
                ? Immutable.fromJS(camelCase(response))
                : response;
        },
    });
}

export default {
    get,
    create,
    update,
    hide,
};
